import type { ComponentType } from 'react';

/**
 * Unmounts a form while it is closed, so every opening starts from its initial
 * state.
 *
 * A create drawer rendered as `<CreateXDrawer open={flag} />` otherwise stays
 * mounted for the life of the page, and whatever was typed — or saved — last
 * time is still there the next time it opens.
 */
export function freshOnOpen<P extends { open: boolean }>(Form: ComponentType<P>) {
  function Fresh(props: P) {
    return props.open ? <Form {...props} /> : null;
  }
  Fresh.displayName = `FreshOnOpen(${Form.displayName ?? Form.name})`;
  return Fresh;
}
